import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { useLogout } from '@hooks/useLogout'

import useStore from '../../store'
import {
  getDsaList,
  saveUserDetails,
  submitSelectedDsa,
  updateProfilePic,
  verifyOtpFunction,
  verifyPhoneNumberFunction,
} from './functions'

export function useVerifyPhoneNumberBridge() {
  return useMutation(verifyPhoneNumberFunction)
}

export function useVerifyOtpBridge() {
  return useMutation(verifyOtpFunction)
}

export function useGetDsaList() {
  return useQuery(['getDsaList'], getDsaList, {
    enabled: false,
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: false,
  })
}

export function useSubmitSelectedDsa() {
  const { logout } = useLogout()
  return useMutation(submitSelectedDsa, {
    onError: logout,
  })
}

export function useSaveUserDetails() {
  return useMutation(saveUserDetails)
}

export function useUpdateProfilePic() {
  const { setUser, user, selectedDsaId } = useStore((state) => state)
  const queryClient = useQueryClient()
  return useMutation(updateProfilePic, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['getAdvisorDetails', selectedDsaId],
      })
      queryClient.invalidateQueries({
        queryKey: ['userContext'],
      })
    },
  })
}
